import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Output } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { initialValuesOutput, validationSchemaOutput } from "./OutputCommon"
import { useCreateOutput } from "../../hooks/outputs"
import OutputForm from "./OutputForm"

export default function OutputCreate() {
  const createOutput = useCreateOutput()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesOutput(), [])
  const validationSchema = useMemo(() => validationSchemaOutput(), [])

  useBreadcrumbs([{ label: "Output", href: "/outputs/outputs" }, { label: "Creazione Output" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo output</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createOutput.mutateAsync(values as Output).then((output) => {
                navigate(`/outputs/outputs/${output.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <OutputForm />
                </Container>
                <BottomFormFixed url="/outputs/outputs" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
